import { render, staticRenderFns } from "./ConfirmModalComponent.vue?vue&type=template&id=265b0fea"
import script from "./ConfirmModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfirmModalComponent.vue?vue&type=style&index=0&id=265b0fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports